import { efaAddToCart } from './add-to-cart-en.i18n';

export const en = {
  efaAddToCart
};
